import React, { useState } from 'react';
import ProfileIdentity from '../../components/content/ProfileIdentity';
function AuthorAvatar({ image, name }) {
  const [failed, setFailed] = useState(false);
  return image && !failed ? (
    <img src={image} alt="" loading="lazy" onError={() => setFailed(true)} />
  ) : (
    name?.slice(0, 1)
  );
}
export default function PlaylistAuthor({ playlist }) {
  return (
    <span className="pp-playlist-author">
      <span className="pp-playlist-author-avatar" aria-hidden="true">
        <AuthorAvatar
          key={playlist.userProfileImageUrl || ''}
          image={playlist.userProfileImageUrl}
          name={playlist.username}
        />
      </span>
      <ProfileIdentity name={playlist.username} mark={playlist.userProfileMark} avatar={false} />
    </span>
  );
}
